export enum PreselectTemplateKeysEnum {
  REQUEST_LEAD_MAIL = "request_lead_mail",
  REQUEST_CLEARANCE_APPROVAL_MAIL = "request_clearance_approval_mail",
  REQUEST_CLEARANCE_MAIL = "request_clearance_mail",
  REQUEST_REPORT_ATTACHMENT_MAIL = "request_report_attachment_mail",
  REQUEST_REPORT_ATTACHMENT_SMS = "request_report_attachment_sms",
  REQUEST_REPORT_MAIL = "request_report_mail",
  REQUEST_REPORT_SMS = "request_report_sms",
  REQUEST_REPAIR_ESTIMATE_ACCEPT_MAIL = "request_repair_estimate_accept_mail",
  REQUEST_REPAIR_ESTIMATE_MAIL = "request_repair_estimate_mail",
  REQUEST_REPAIR_ESTIMATE_REJECT_MAIL = "request_repair_estimate_reject_mail",
  REQUEST_SIGNATURE_MAIL = "request_signature_mail",
  REQUEST_SNAPSHOT_SIGNATURE_MAIL = "request_snapshot_signature_mail",
  REQUEST_APPRAISAL_MAIL = "request_appraisal_mail",
  REQUEST_DOCUMENT_MAIL = "request_document_mail",
  CREATE_RENTAL_MAIL = "create_rental_mail",
  UPDATE_RENTAL_MAIL = "update_rental_mail",
  UPDATE_REPORT_STATUS_MAIL = "update_report_status_mail",
  CLAIM_SETTLEMENT_MAIL = "claim_settlement_mail",
  REQUEST_UBA_REVIEW_MAIL = "request_uba_review_mail",
  FLEET_EVENT_MAIL_WITH_VEHICLE = "fleet_event_mail_with_vehicle",
  EVENT_MAIL = "event_mail",
  SEND_INVOICE_MAIL = "send_invoice_mail",

  /** Invite mail sent to a newly created partner user, after its permissions are set. */
  INVITE_PARTNER_USER_MAIL = "invite_partner_user_mail",

  /**
   * Invite mail for an admin user, sent manually from the user detail. Admin users are not partner
   * scoped, so the sending partner — and with it the template — is picked when composing.
   */
  INVITE_ADMIN_USER_MAIL = "invite_admin_user_mail",

  /** Invite mail sent to a newly created fleet user (fleet manager), after its fleet permissions are set. */
  INVITE_FLEET_USER_MAIL = "invite_fleet_user_mail",

  /** Completion mail of a retention call with outcome self checkout: the link to check out. */
  CHURN_CALL_SELF_CHECKOUT_MAIL = "churn_call_self_checkout_mail",

  /** Completion mail of a retention call with outcome not reached: the link plus the request to check out. */
  CHURN_CALL_NOT_REACHED_MAIL = "churn_call_not_reached_mail",

  /** Completion mail of a retention call with outcome callback: the offer plus the link. */
  CHURN_CALL_CALLBACK_MAIL = "churn_call_callback_mail"
}
